import { regionFixedExchangeRate } from 'services/config/region';
import { formatNumber, NumeralFormatPattern } from 'utils/numberFormat';

export const currencySymbol: Record<General.Currency, string | undefined> = {
  CNY: regionFixedExchangeRate?.CN?.symbol,
  USD: regionFixedExchangeRate?.US?.symbol,
  IDR: regionFixedExchangeRate?.ID?.symbol,
  THB: regionFixedExchangeRate?.TH?.symbol,
  MXN: regionFixedExchangeRate?.MX?.symbol,
  VND: regionFixedExchangeRate?.VN?.symbol,
  BRL: regionFixedExchangeRate?.BR?.symbol,
  PHP: regionFixedExchangeRate?.PH?.symbol,
  MYR: 'Mal.＄',
};

export interface PriceTextProp {
  currency: General.Currency;
  price: number;
  format?: NumeralFormatPattern;
}

export const PriceText = (props: PriceTextProp) => {
  const { currency, price, format = '0,0[.]00' } = props;
  return (
    <>
      {currencySymbol[currency]}
      {formatNumber(price, format)}
    </>
  );
};
